import React, { useEffect } from 'react';
import { Modal as ShowroomModal } from '@carvana/core-helios-modal';
import { datadogRum } from '@datadog/browser-rum';
import { AnalyticEvents, DateMasks } from '@constants/index';
import rootStyles from '@components/service-and-repair/service-and-repair.module.css';
import { Analytics } from '@services/analytics-service';
import { formatDate } from '@services/UtilitiesService';
import styles from './concern-details.module.css';
import { Concern } from '../reported-concern-type';

export const ConcernDetailsModal = ({
  modalIsOpen,
  setModalIsOpen,
  cosmeticConcern,
}: {
  modalIsOpen: boolean;
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  cosmeticConcern: Concern;
}) => {
  useEffect(() => {
    if (!modalIsOpen) return;

    Analytics.trackEvent(AnalyticEvents.sarSubmittedCasesViewedConcernDetails, {
      submissionDate: cosmeticConcern?.createdOn,
      concernDetails: cosmeticConcern?.details,
    });
    datadogRum.addAction(AnalyticEvents.sarSubmittedCasesViewedConcernDetails, {
      submissionDate: cosmeticConcern?.createdOn,
      concernDetails: cosmeticConcern?.details,
    });
  }, [modalIsOpen]);

  const onCloseModal = () => {
    setModalIsOpen(false);
    Analytics.trackEvent(AnalyticEvents.sarSubmittedCasesDismissedConcernDetails);
    datadogRum.addAction(AnalyticEvents.sarSubmittedCasesDismissedConcernDetails);
  };

  const { isLegacy, category, subCategory } = cosmeticConcern || {};
  const interiorOrExterior = isLegacy ? category : subCategory;

  return (
    <ShowroomModal
      closeModal={onCloseModal}
      isOpen={modalIsOpen}
      headerText="Concern details"
      className={rootStyles['modal']}
    >
      <div className={styles['reported-concern']}>
        <div className={styles['reported-concerns-header']}>
          <h4>{interiorOrExterior} cosmetic issue</h4>

          <p>submitted on {formatDate(cosmeticConcern?.createdOn, DateMasks.MMDDYYwSlash)}</p>
        </div>

        <div className={styles['reported-concerns-images']}>
          {cosmeticConcern?.media?.map((image: string, index: number) => (
            <img key={index} src={image} alt="concern" />
          ))}
        </div>

        <div className={styles['reported-concerns-footer']}>
          We&apos;ve submitted your issue to our coverage provider, SilverRock™. They will contact you via email within
          48 hours with next steps.
        </div>
      </div>
    </ShowroomModal>
  );
};
